import React from 'react';
import ReactDOM from 'react-dom';
import Classes from 'classnames';
import PresenceConnectivity from '../../layout/components/connectivity/connectivity';
import AmpersandSate from 'ampersand-state';

import _ from 'lodash';
import $ from 'jquery';

import LayoutAnalytics from '../../layout/analytics/analytics.ts';
import LayoutNew from 'layout/layout/quick-add/quick-add';
import LayoutTop from '../../layout/top/layout-top.ts';

import UIFullModal from "../../layout/components/full-modal/full-modal"
import LayoutLocalSettings from '../../layout/layout/local-settings';

import LayoutLoading from "../../layout/components/loading/loading";
import ConstLayout from "../../core/gd/const/layout";
import LayoutViewLoading from "layout/components/view-loading/loading";
import LayoutItemView from "../../layout/item-view/layout-item-view";
import {SharedViewLogo} from "../core/logo/logo";
import calculateNativeScrollWidth from "../../layout/layout/actions/calculate-native-scroll-width";
import getScreenSize from "../../layout/layout/actions/get-screen-size";
import getLeftSize from "../../layout/layout/actions/get-left-size";
import Popovers from "../../layout/popovers/popovers"
import {UIType} from "layout/ui/@const";
import {BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED} from "layout/layout/bus-events";

const debug = {
    dev: false,
    head: "{Layout}"
};

const LayoutAppProto = AmpersandSate.extend({

    props: {
        width: 'number',            // window width
        height: 'number',           // window height

        widthMain: 'number',        // main area with
        heightMain: 'number',       // main area height

        isRightFilterOpened: {
            type: 'boolean',
            default: false
        },

        // isLeftMinimized: {
        //     type: 'boolean',
        //     default: false
        // },

        currentSection: {
            type: 'number',
            default: 'home'
        }

    },

    leftSize: '',
    leftForcedMin: false,

    scrollWidth: 0,

    domZero: false,


    widthToAutoToggleMenu: 1100, // this should be redefined for eatch layout!
    menuOpen: 200,//234,
    menuClosed: 60, //50
    topPanel: 50,


    fullModal: new UIFullModal(),

    // Layout Apps

    analytics: new LayoutAnalytics(),   // everything related to analytics
    new: new LayoutNew(),   // everything related to task
    left: null, // Left component
    top: new LayoutTop(),   // everything related to task
    localSettings: null,

    popovers: new Popovers(),

    fullScreenEnabled: false,

    menuMinPopoverShown: false,

    __destroy() {
        // a nahrena ?
        if (debug.dev) console.log(debug.head,"__destroy");
        window.removeEventListener('resize', this.debouncedWinResize);
    },

    init() {
        if (debug.dev) console.log(debug.head,"init");
        this.localSettings = new LayoutLocalSettings();
        this.leftForcedMin = this.localSettings.forcedMin;

        // on Window Resize
        this.debouncedWinResize = _.debounce(this.onWindowResize.bind(this), 300);
        window.addEventListener('resize', this.debouncedWinResize);

        this.scrollWidth = calculateNativeScrollWidth() || 0

        const screenSize = getScreenSize()
        this.width = screenSize.width;
        this.height = screenSize.height;


        if (this.leftForcedMin) {
            this.leftSize = 'min';
        } else {
            this.leftSize = getLeftSize(this.width)
        }


        return this;
    },

    calculateWidth(silentMode=false) {

        if (debug.dev) console.log(debug.head,"calculate width");
        this.width = document.body.offsetWidth;
        this.heightMain = document.getElementById('ui-content-center').offsetHeight;
        this.height = document.body.offsetHeight;

        if (!silentMode) {
            this.widthMain = document.getElementById('ui-content-center').offsetWidth;
        } else {
            this.set({
                widthMain: document.getElementById('ui-content-center').offsetWidth
            },{
                silent: true
            });
        }
    },

    setRightFilterOpen(value) {
        this.isRightFilterOpened = value;
    },

    onWindowResize() {
        if (debug.dev) console.log(debug.head,"onWindowResize");

        // screen width
        const screenSize = getScreenSize()
        this.width = screenSize.width;
        this.height = screenSize.height;


        // check if left size changes
        let newLeftSize = false;
        if (!this.leftForcedMin) {
            newLeftSize = getLeftSize(screenSize.width);
            if (this.leftSize == newLeftSize) newLeftSize = false;
        } else {
            newLeftSize = 'min';
            if (this.leftSize == newLeftSize) newLeftSize = false;
        }

        // if left size changed - apply it
        if (newLeftSize) {
            // div0 apply classes
            const oldLeftSize = this.leftSize;
            this.leftSize = newLeftSize;

            if (newLeftSize=='min') gd.bus.triggerEvent('layout:min:on');
            else if (oldLeftSize=='min') gd.bus.triggerEvent('layout:min:off');

            gd.utils.Dom.removeAllClasses(this.domZero);
            gd.utils.Dom.addClasses(this.domZero, 'ui-layout','left-'+newLeftSize, this.type);


        }

        // well ... if menu min... let's update



        this.calculateWidth();
        this.checkMenuAutoToggle();

        // auto switch task view layout
        if (this.task.isOpen) {
            this.task.close({closeOnResize:true});
            this.task.open(gd.settings.taskView.get("layout"));
        }

        if (debug.dev) console.log(debug.head,".onWindowResize new widthFull=",this.width," widthMain=",this.widthMain);
    },

    applyTopPanelSettings(value) {

        if (!value) {
            this.top.close();
        } else {

            let newHeight = ConstLayout.TOP_WITHOUT_SUBMENU;

            if (value.companyId) {
                newHeight = ConstLayout.TOP_WITHOUT_SUBMENU;
            }

            if (value.companyUserId) {
                newHeight = ConstLayout.TOP_WITH_SUBMENU;
            }

            if (value.projectId) {
                const project = gd.session.projects.get(value.projectId);
                if (project) newHeight = ConstLayout.TOP_WITH_SUBMENU;
            }

            // custom height
            if (value.height) newHeight = value.height;


            if (value.extensions) {
                // first exteneded line
                newHeight += value.extensions[0];

                // second line ?
                if (value.extensions.length>2) {
                    newHeight += value.extensions[2];
                }
            }

            this.top.open(newHeight);

        }

        this.calculateWidth();
    },

    fullScreen(enabled) {
        this.fullScreenEnabled = enabled;

        if (enabled) {

            gd.bus.triggerEvent("full-screen:on");

            this.left.hide(); // hide left

            // const $uiMainCenter = $("#ui-main-center"); // center make full
            // $uiMainCenter.addClass('full-screen');

            const $uiLayout = $("#ui-div-zero"); // center make full
            $uiLayout.addClass('full-screen');

            gd.layout.top.fullScreen(true);


        } else {

            gd.bus.triggerEvent("full-screen:off");

            this.left.show();

            gd.layout.top.fullScreen(false);

            this.top.open();

            // const $uiMainCenter = $("#ui-main-center");
            // $uiMainCenter.removeClass('full-screen');

            const $uiLayout = $("#ui-div-zero"); // center make full
            $uiLayout.removeClass('full-screen');

        }

        setTimeout(()=>{gd.layout.calculateWidth()},0);
    },

    isFullScreenEnabled() {
        return this.fullScreenEnabled;
    },

    //menu layout methods
    checkMenuAutoToggle(){

        /*if (this.width <= this.widthToAutoToggleMenu){
            this.left.autoToggle(false);
        } else if (this.width > this.widthToAutoToggleMenu){
            this.left.autoToggle(true);
        }*/
    },


    toggleForceMin() {

        this.leftForcedMin = !this.leftForcedMin;

        this.localSettings.forcedMin = this.leftForcedMin;
        this.localSettings.save();

        this.onWindowResize();
    },

    // autoToggleMenu(open){
    //     this.left.autoToggle(open);
    // },

    // toggleMenu(value){
    //     this.left.toggle(value);
    // },

    toggleMenuMinPopover(value) {
        this.menuMinPopoverShown = !_.isNil(value) ? value : !this.menuMinPopoverShown;
        gd.bus.triggerEvent(BUS_LAYOUT_MENU_MIN_POPOVER_CHAGED, this.menuMinPopoverShown);
    },

    render(options={}) {
    }

});


class LayoutApp extends LayoutAppProto {

    constructor() {
        super();

        this.type = UIType.SHARED_VIEW
    }

    render(options={}) {

        if (debug.dev) console.count("{Layout} render");

        const zeroClasses = Classes('ui-layout','shared-view');

        ReactDOM.render(
            <div id="ui-div-zero" className={zeroClasses}>

                {/*<SharedViewLogo />*/}

                <div id="ui-top-panel"/>
                <div id="ui-content-center" className=""/>

                <LayoutItemView />
                <div id="ui-modal"/>

                <PresenceConnectivity />
                <LayoutLoading />
                <LayoutViewLoading />
            </div>,
            document.getElementById("ui-layout-container")
        );

        this.domZero = document.getElementById("ui-div-zero");

        //Init main area size
        this.calculateWidth();
    }


}

module.exports = LayoutApp;
